module.exports = "/_next/static/images/StreamlineCompliance-c41df7dbc4c56a13162327b6d41e3bf7.webp";